export default ({ intl }) => [
  intl.formatMessage({ id: 'Atualização Online' }),
  intl.formatMessage({ id: 'Rápido e fácil' }),
  intl.formatMessage({ id: 'Administrado por sua empresa' }),
  intl.formatMessage({ id: 'Menor custo no mercado' }),
  intl.formatMessage({ id: 'Aprovado por mais de 300 clientes e 1 milhão de usuários' }),
];
